<template>
<div>
  <b-row>
    <b-col sm="12" md="12" lg="12">
      <b-card>
        <h5>Listado de Solicitudes</h5>
        <tabla-base
          detallerender="solicitud"
          :items="listaSolicitudes.rows"
          :fields="listaSolicitudes.fields">
          <template #cell(acciones)="row">
            <div>
                <b-dropdown id="ddown-divider" right text="Acciones" class="m-2" size="sm" variant="primary">
                <b-dropdown-item-button  @click.stop="verDetalles(row.item, row.index, row.detailsShowing, row.toggleDetails)"> {{ row.detailsShowing ? 'Ocultar' : 'Ver' }} detalles</b-dropdown-item-button>
                <b-dropdown-item-button v-if="(isInRoleAdmin||((row.item.UnidadEducativaNivelString !== 'NULL' &&  isInRoleEstablecimiento)||(isInRoleCoordinador && row.item.UnidadEducativaNivelString === 'NULL'))&&(row.item.EstadoSolicitudMedicaString === 'Enviado' || row.item.EstadoSolicitudMedicaString === 'FueraTermino'))"  @click.stop="modalActualizar(row.item, row.index, $event.target)">Modificar estado</b-dropdown-item-button>
                </b-dropdown>
            </div>
          </template>
          <template slot="table-caption">
            <b-row>
              <b-col md="8">
                <small><b>Cantidad de solicitudes :</b></small> <b-badge variant="success">{{ listaSolicitudes.totalRows }}</b-badge>
              </b-col>
              <b-col sm="4" md="4" lg="4" class="mr-0 text-right">
                <font-awesome-icon icon="circle" class="text-success "/> Autorizado
                <font-awesome-icon icon="circle" class="text-primary"/> Recibido
                <font-awesome-icon icon="circle" class="text-warning"/> Enviado
                <font-awesome-icon icon="circle" class="text-danger"/> F. de Término
              </b-col>
            </b-row>
          </template>
        </tabla-base>
      </b-card>
      <paginacion-solicitud></paginacion-solicitud>
    </b-col>
  </b-row>
</div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import PaginacionSolicitud from "../common/PaginacionSolicitud.vue";
import TablaBase from "../common/TablaBase.vue";

const { mapFields } = createHelpers({
  getterType: 'SolicitudModule/getSolicitudField',
  mutationType: 'SolicitudModule/updateSolicitudField',
});

export default {
  name: "TablaSolicitud",
  watch: {
  },
  components: {
    PaginacionSolicitud,
    TablaBase
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "getUserName",
      "getUserInfo",
      "isInRoleAdmin",
      "isInRoleCoordinador",
      "isInRoleEstablecimiento",
      "getEstablecimiento"
    ]),
    ...mapFields({
      filtroEstado: 'filtro.estado',
      filtroDestino: 'filtro.destino',
      listaSolicitudes: 'tabla',
      solicitudSeleccionada: 'selected'
    }),
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions("SolicitudModule",["solicitudProvider", "getSolicitud",]),
    verDetalles(item, index , detailsShowing, callback) {
      console.log('verDetalles',item.Id, index, detailsShowing);
      this.getSolicitud(item.Id).then(e =>{
        console.log('getSolicitud then');
        callback();
      });
    },
    solicitudProviderLocal: function() {
      console.log('resetPagination 2', false);
      return this.solicitudProvider(false);
    },
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/TablaSolicitud.vue